import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { IonLoading, IonImg, IonButton, IonList, IonText } from '@ionic/react';
import { InputField } from 'components/form';
import AppActions from 'redux/AppRedux';
import api_v2 from 'services/api_v2';
import { sanitizePhone } from 'utils/phone';
import AuthActions from 'redux/AuthRedux';
import schema from './schema';

const INITIAL_VALUES = {
  phone: '',
};

/* US Number format */
function isTenDigitsNumber(str) {
  return /^\d{10}$/.test(str);
}

function SignFlowForm() {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleSubmit = async (values, actions) => {
    try {
      const api = api_v2();

      const phone = `+1${values.phone}`;

      await api.userExist(phone);

      history.push(`/auth/login?phone=${values.phone}`);
    } catch (e) {
      if (e.code === 'USER_NOT_FOUND') {
        dispatch(
          AuthActions.saveSignup({
            phone: sanitizePhone(values.phone),
          })
        );
        const data = { phone: sanitizePhone(values.phone), type: 'signup' };
        await api_v2().requestSmsCode(data);
        history.push('/verify-code');
      } else {
        setTimeout(() => {
          dispatch(AppActions.setToast(e.message, 'danger'));
        }, 100);
      }

      actions.setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{ ...INITIAL_VALUES }}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {({ isSubmitting, errors, values }) => {
        return (
          <Form>
            <IonLoading isOpen={isSubmitting} message="Loading..." />
            <IonList>
              <div className="auth-h-logo">
                <IonImg src="/assets/vemospay-h-logo.png" />
              </div>
              <div className="auth-title">
                View, split and pay your check at restaurants & bars.
              </div>
              <div className="auth-subtitle">No fees. More secure.</div>

              <IonText color="dark" className="mb-2x">
                <strong>Enter your phone number to get started</strong>
              </IonText>

              <Field
                component={InputField}
                name="phone"
                type="tel"
                warningText={
                  values.phone.length > 0 && !isTenDigitsNumber(values.phone)
                    ? 'Phone number must be 10 digits'
                    : ''
                }
              />
              <IonText color="medium" className="mb-2x">
                <small>Use format 6123334444</small>
              </IonText>

              <div
                style={{
                  margin: '2rem auto 0 auto',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <IonButton
                  color="tertiary"
                  fill="solid"
                  type="submit"
                  disabled={
                    errors.phone ||
                    !isTenDigitsNumber(values.phone) ||
                    isSubmitting
                  }
                  className="sign-btn"
                >
                  Continue
                </IonButton>
              </div>
            </IonList>
          </Form>
        );
      }}
    </Formik>
  );
}

export default SignFlowForm;
